import Styles from './block.module.scss';
import { useNode } from '@craftjs/core';
import { FormTextComponent } from 'src/features/generalForms/builder/types/Text';

export const TextBlock: FormTextComponent = ({ text }) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));

  return (
    <div style={{ ...styles }} className={Styles.textEditableFill}>
      {text}
    </div>
  );
};
